import * as D from '../../../utils/dbmodel';

export default {
    namespaced: true,
    state: {
        searchP: {
            syscode: '',//系统编码
            sysname: '',//系统名称姓名
            ownercode: '',//所属组织
            syscategory: '',//分类
            domain: '',//领域
            sysadmin: '',//负责人
        },
        list: [], //table中的list显示数据
        pagination: {

        }, //分页相关的信息
        record: {
        }, //根据id查询的数据详情信息
    },

    getters: {
        getDomainnameSelectOptions (state) {
            return state.domainnameSelectOptions
        }
    },

    mutations: {
        save (state, action) {
            // console.log(action, "commit")
            // state = { ...state, ...action.payload }   //这么写不行，必须要遍历挨个重新赋值
            // state.domainnameSelectOptions = action.payload.domainnameSelectOptions
            for (var key in action.payload) {
                state[key] = action.payload[key]
            }
            // console.log(state, " yo ?") //跟console.log({ ...state, ...action.payload }) 的值是不一样的, 所以不能直接用展开运算符
        }
    },
    actions: {
        //查询系统列表信息
        selectSys (context, payload) {
            payload.type = 'sys/querysys'
            return D.select({
                ...payload
            })
        },
        refreshAppVersion (context, payload) {
            payload.type = 'sys/refreshAppVersion'
            return D.edit({
                ...payload
            })
        },
        //获取系统下拉框
        sysSelecter (context, payload) {
            payload.type = 'sys/selectsys'
            return D.select({
                ...payload
            })
        },
        //编辑，查看
        detailSys (context, payload) {
            payload.type = 'sys/detailSys'
            return D.detail({
                ...payload
            }).then(response => {
                const { data } = response.data;
                context.commit({
                    type: 'save',
                    payload: {
                        record: data
                    }
                })
                return response
            })

        },
        getEmptySys (context) {
            const V5_HOST = ['fsim', 'fuat', 'fsit', 'fdev', 'fpet', 'f'];
            const is_v5 = V5_HOST.indexOf(window.location.host.split('.')[0]) != -1
            context.commit({
                type: 'save',
                payload: {
                    record: {
                        version: is_v5 ? 'V5.0' : 'V3.0',
                    }
                }
            })
        },
        getEmptySearch (context) {
            context.commit({
                type: 'save',
                payload: {
                    searchP: {
                        syscode: '',//系统编码
                        sysname: '',//系统名称姓名
                        ownercode: '',//所属组织
                        syscategory: '',//分类
                        domain: '',//领域
                        sysadmin: '',//负责人
                    }
                }
            })
        },
        addSys (context, payload) {
            payload.type = 'sys/addsys'
            return D.add({
                ...payload
            })
        },
        editSys (context, payload) {
            payload.type = 'sys/editsys'
            return D.edit({
                ...payload
            })
        },
        deleteSys (context, payload) {
            payload.type = 'sys/deletesys'
            return D.del({
                ...payload
            })
        },

        //域名列表
        addDomainUrl (context, payload) {
            return D.add({
                ...payload
            })
        },
        selectDomainUrl (context, payload) {
            return D.select({
                ...payload
            })
        },
        detailDomainUrl (context, payload) {
            return D.select({
                ...payload
            })
        },
        deleteDomainUrl (context, payload) {
            return D.del({
                ...payload
            })
        },
        updateDomainUrl (context, payload) {
            return D.edit({
                ...payload
            })
        },
        bindPlatforms (context, payload) {
            return D.edit({
                ...payload
            })
        },
        querybinds (context, payload) {
            return D.select({
                ...payload
            })
        },
    }
}